<script setup lang="ts">
import { computed } from 'vue';
import useContext from '@/composables/useContext';
import useGiftCard from '@/composables/useGiftCard';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { LogOutIcon } from 'lucide-vue-next';

const props = defineProps({
  showIcon: {
    type: Boolean,
    required: false
  }
});

const { channel, navigate } = useContext();
const { removeAllGiftCards } = useGiftCard();
const { websiteText } = useWebsiteTexts();
const rootPath = computed(() => {
  return channel.value?.rootPath || '';
});

async function logout() {
  try {
    await removeAllGiftCards();

    if (rootPath.value) {
      await navigate(rootPath.value);
    }
  } catch (ex) {
    console.warn(ex);
    alert(websiteText('global__failed_to_remove_giftcard').value);
  }
}
</script>

<template>
  <div class="pointer select-none flex flex-row gap-3 hover:underline" @click="logout()">
    <LogOutIcon v-if="showIcon" class="h-4 w-4 text-muted-foreground" />
    {{ websiteText('header_giftcardlogout').value }}
  </div>
</template>